import {useActions} from "../../../hooks/useActions";
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {MusicService} from "../../../services/MusicService";

function ButtonPlayNewAcc() {

    const {isLoading} = useTypedSelector(state => state.auth);

    const {
        authNewUser,
        startLoadingGame
    } = useActions();

    return <div className="loginButtonPlayAsNew defaultButtonAnimation" onClick={async () => {
        if(isLoading){
            return;
        }

        await authNewUser();
        await startLoadingGame();
        MusicService.playMenuMusic();
    }}>
    </div>

}

export default ButtonPlayNewAcc;
